/**
 * @author      Suyog Manandhar
 * @version     2.0
 * @description This Custom Collapse Component was made with very hard effort :P
 *              with help of @author Sandeep Shakaya incooperated.
 */

import React, { Component } from "react";
import { Collapse, CardBody, Card } from "reactstrap";

class CustomCollapse extends Component {
  render() {
    return (
      <Collapse isOpen={this.props.isOpen} className={this.props.collapseClass}>
        <Card>
          <CardBody>{this.props.collapsibleBody}</CardBody>
        </Card>
      </Collapse>
    );
  }
}

export default CustomCollapse;
